import { zustandLogger } from '@/lib/zustand';
import { create } from 'zustand';

/**
 * ページ離脱確認用に、アプリ全体でフォームの "未保存変更あり" 状態 (dirty) を一元管理するストア。
 */
type FormDirtyState = {
  /** 未保存の変更があるかどうか */
  isDirty: boolean;
  /** dirty 状態を設定する */
  setIsDirty: (isDirty: boolean) => void;
  /** dirty 状態をリセットする */
  reset: () => void;
};

export const useFormDirtyStore = create<FormDirtyState>()(
  zustandLogger('formDirty')((set) => ({
    isDirty: false,
    setIsDirty: (isDirty) => set({ isDirty }),
    reset: () => set({ isDirty: false }),
  })),
);
